import './styles/harmonica.scss';
import './harmonica.js';
import './controllers/harmonicaController.js';
import './controllers/harmonicaTileController.js';
import './directives/harmonicaDirectives.js';